import {
    getQueryKey,
    initialArticleSearchByQueryState,
    initialArticleSearchPageState,
    ArticleSearchByQueryState,
    ArticleSearchPageState,
} from 'mk2/apps/wiki/containers/ArticleSearch/ArticleSearch.reducers';
import { AppState } from 'mk2/reducers';

export const getArticleSearchPagesState = (state: AppState): ArticleSearchPageState =>
    state.containers.wiki.articleSearch || initialArticleSearchPageState;


export const getArticleSearchState = (state: AppState, categorySlug: string, articleSlug: string, query: string): ArticleSearchByQueryState => {
    const key = getQueryKey(categorySlug, articleSlug, query);
    return getArticleSearchPagesState(state).search[key] || initialArticleSearchByQueryState;
};
